import { render, staticRenderFns } from "./DefectJudgmentModal.vue?vue&type=template&id=50c10e18&scoped=true"
import script from "./DefectJudgmentModal.vue?vue&type=script&lang=js"
export * from "./DefectJudgmentModal.vue?vue&type=script&lang=js"
import style0 from "./DefectJudgmentModal.vue?vue&type=style&index=0&id=50c10e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c10e18",
  null
  
)

export default component.exports